import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import "react-datepicker/dist/react-datepicker.css";

// Toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function IAreports() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryAdminToken");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  const [loading, setLoading] = useState(false);

  // ---------- MODAL STATES ----------
  const [selectedReport, setSelectedReport] = useState(null);

  //   useEffect(() => {
  //     if (!token) {
  //       navigate("/secondary-admin");
  //     }
  //   }, []);

  //   useEffect(() => {
  //     if (!permissions[10]?.caN_VIEW) {
  //       navigate("/secondary-admin-dashboard");
  //     }
  //   }, [permissions, navigate]);

  const reportOptions = [
    {
      label: "Class IX District Wise IA Reports",
      url: `${config.API_BASE_URL}/ReportDistWiseCountJACIACL_9`,
      method: "GET",
      dataPath: `data["reportDistWiseCountCL9_data"]`,
      buttonClass: "btn-danger",
    },
    {
      label: "Class IX District Wise School Wise IA Reports",
      url: `${config.API_BASE_URL}/ReportDistSchoolWiseCountJACIACL_9`,
      method: "GET",
      dataPath: `data["reportDistSchoolWiseCountCL9_data"]`,
      buttonClass: "btn-success",
    },
    {
      label: "Class X District Wise IA Reports",
      url: `${config.API_BASE_URL2}/ReportDistWiseCountJACIACL_10`,
      method: "GET",
      dataPath: `data["reportDistWiseCountCL10_data"]`,
      buttonClass: "btn-primary",
    },
    {
      label: "Class X District Wise School Wise IA Reports",
      url: `${config.API_BASE_URL2}/ReportDistSchoolWiseCountJACIACL_10`,
      method: "GET",
      dataPath: `data["reportDistSchoolWiseCountCL10_data"]`,
      buttonClass: "btn-info",
    },
  ];
  const specialReports = [
    {
      label: "Class IX District Wise IA Reports",
      url: `${config.API_BASE_URL}/CS_ExamReportDistWiseCountJACIA_CL9`,
      method: "GET",
      dataPath: `data["csExamReportDistwiseJACIA_list"]`,
      buttonClass: "btn-danger",
      fileName: "CL_9_Special_Exam_District_Wise_IA_reports.xlsx",
    },
    {
      label: "Class IX District Wise School Wise IA Reports",
      url: `${config.API_BASE_URL}/CS_ExamReportDistSchoolWiseCountJACIA_CL9`,
      method: "GET",
      dataPath: `data["csExamReportDistSchoolwiseJACIA_list"]`,
      buttonClass: "btn-success",
      fileName: "CL_9_Special_Exam_District_Wise_School_Wise_IA_reports.xlsx",
    },
    {
      label: "Class X District Wise IA Reports",
      url: `${config.API_BASE_URL2}/CS_ExamReportDistWiseCountJACIA_CL10`,
      method: "GET",
      dataPath: `data["csExamReportDistwiseJACIA_list"]`,
      buttonClass: "btn-danger",
      fileName: "CL_10_Special_Exam_District_Wise_IA_reports.xlsx",
    },
    {
      label: "Class X District Wise School Wise IA Reports",
      url: `${config.API_BASE_URL2}/CS_ExamReportDistSchoolWiseCountJACIA_CL10`,
      method: "GET",
      dataPath: `data["csExamReportDistSchoolwiseJACIA_list"]`,
      buttonClass: "btn-success",
      fileName: "CL_10_Special_Exam_District_Wise_School_Wise_IA_reports.xlsx",
    },
  ];
  // const supplementaryReports = [
  //   {
  //     label: "Supplementary District Wise IA Reports",
  //     url: `${config.API_BASE_URL}/CS_FailExamReportDistWiseCountJACIA_CL9`,
  //     method: "GET",
  //     dataPath: `data["failExamReportDistwiseJACIA_list"]`,
  //     buttonClass: "btn-primary",
  //     fileName: "CL_9_Supplymentary_Exam_District_Wise_IA_Reports.xlsx",
  //   },
  //   {
  //     label: "Supplementary District Wise School Wise IA Reports",
  //     url: `${config.API_BASE_URL}/CS_FailExamReportDistSchoolWiseCountJACIA_CL9`,
  //     method: "GET",
  //     dataPath: `data["failExamReportDistSchoolwiseJACIA_list"]`,
  //     buttonClass: "btn-info",
  //     fileName: "CL_9_Supplymentary_Exam_SchoolWise_District_Wise_School_Wise_IA_Reports.xlsx",
  //   },
  // ];
  // ---------------- FETCH WITHOUT DATE --------------------
  const fetchReportData = async (reportConfig) => {
    if (!reportConfig) {
      Swal.fire("Invalid report type.", "", "error");
      return;
    }

    if (!token) {
      Swal.fire("Auth Error", "Token is missing. Please login.", "error");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(reportConfig.url, {
        method: reportConfig.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      const extractedData =
        getValueFromPath(result, reportConfig.dataPath) || [];

      if (!extractedData.length) {
        Swal.fire("No data found.", "", "info");
        return;
      }

      generateExcel(
        extractedData,
        reportConfig.label,
        reportConfig.fileName
      );
    } catch (error) {
      Swal.fire("Error", "Error fetching report.", "error");
    } finally {
      setLoading(false);
    }
  };

  const getValueFromPath = (obj, path) => {
    try {
      return path
        .replace(/\[(["']?)([^\[\]"']+)\1\]/g, ".$2")
        .replace(/^\./, "")
        .split(".")
        .reduce((acc, key) => acc?.[key], obj);
    } catch {
      return undefined;
    }
  };

  const generateExcel = (data, title, fileName) => {
    try {
      const headers = ["Sl. No.", ...Object.keys(data[0])];
      const formattedHeaders = [
        "SL. NO.",
        ...Object.keys(data[0]).map((k) => k.toUpperCase()),
      ];

      const now = new Date();
      const dateStr = `${String(now.getDate()).padStart(2, "0")}-${String(
        now.getMonth() + 1,
      ).padStart(2, "0")}-${now.getFullYear()}  ${now
        .toLocaleTimeString("en-GB")
        .toUpperCase()}`;

      const ws = XLSX.utils.aoa_to_sheet([
        [`Report: ${title}`],
        [`Generated on: ${dateStr}`],
        [],
        formattedHeaders,
      ]);

      const rows = data.map((item, i) => [
        i + 1,
        ...headers.slice(1).map((key) => item[key] ?? ""),
      ]);

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: formattedHeaders.length - 1 } },
      ];

      ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const safeFileName = `Secondary_IA_${title.replace(
        /[^a-zA-Z0-9]/g,
        "_",
      )}.xlsx`;

      XLSX.writeFile(wb, fileName || safeFileName);

      Swal.fire("Success", "Excel file downloaded", "success");
    } catch (err) {
      Swal.fire("Error", "Failed to generate Excel", "error");
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        style={{ zIndex: "100001" }}
      />
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <section className="content-header mb-4">
                <h1>
                  <i className="fa fa-university" />
                  Secondary IA Reports
                </h1>
                <ol className="breadcrumb">
                  <li>
                    <a
                      onClick={() => navigate("/secondary-admin-dashboard")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa fa-tachometer mr-2"></i> Home
                    </a>
                  </li>
                  <li className="active">Secondary IA Reports</li>
                </ol>
              </section>

              <div className="row">
                <div className="row">
                  {/* IA Reports */}
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-header">
                        <h5>IA Reports</h5>
                      </div>
                      <div className="card-body">
                        <table className="table">
                          <tbody>
                            {reportOptions.map((report, index) => (
                              <tr key={index}>
                                <td>
                                  <button
                                    className={`btn ${report.buttonClass} w-100`}
                                    style={{ textAlign: "left" }}
                                    onClick={() => fetchReportData(report)}
                                  >
                                    <i className="fa fa-download"></i>&nbsp;
                                    {report.label}
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Special + Supplementary */}
                  <div className="col-md-5">
                    <div className="card">
                      <div className="card-header">
                        <h5>Class IX & X Special & Supplementary Reports</h5>
                      </div>

                      <div className="card-body">
                        <table className="table">
                          <tbody>
                            {[...specialReports].map(
                              (report, index) => (
                                <tr key={index}>
                                  <td>
                                    <button
                                      className={`btn ${report.buttonClass} w-100`}
                                      style={{ textAlign: "left" }}
                                      onClick={() => fetchReportData(report)}
                                    >
                                      <i className="fa fa-download"></i>&nbsp;
                                      {report.label}
                                    </button>
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default IAreports;
